import { Link } from 'react-router-dom';
import { isInSchoolAPEvents } from '../../../../../../utils/event';
import WizardNav from '../../../WizardNav';
// eslint-disable-next-line
import React from 'react';

interface Props {
  stepNum: number;
  lastStep: number;
  // eslint-disable-next-line
  orgEvent?: any;
  roomId: string;
}

export function Navigation({ stepNum, roomId, lastStep, orgEvent }: Props) {
  let prevButton = <></>;
  if (stepNum > 0) {
    prevButton = (
      <Link className='cb-btn cb-btn-sm cb-btn-light' to={`/rooms/get/${roomId}/flow/setup/step/${stepNum - 1}`}>
        Back
      </Link>
    );
  }
  const initialAttendanceStep = isInSchoolAPEvents(orgEvent) ? 0 : 1;

  const nextButton =
    stepNum === lastStep ? (
      <Link
        className='cb-btn cb-btn-sm cb-btn-yellow ml-auto'
        data-automation='nav-nextStep-Link'
        to={`/rooms/get/${roomId}/flow/attendance/step/${initialAttendanceStep}`}
      >
        Next Step
      </Link>
    ) : (
      <Link
        className='cb-btn cb-btn-sm cb-btn-yellow ml-auto'
        data-automation='nav-nextStep-Link'
        to={`/rooms/get/${roomId}/flow/setup/step/${stepNum + 1}`}
      >
        {stepNum === 0 && 'Get Started'}
        {stepNum > 0 && stepNum < lastStep && 'Next Step'}
      </Link>
    );

  return <WizardNav prevButton={prevButton} nextButton={nextButton}></WizardNav>;
}
